import { BirthdayRequirement, CouponIdList, LoyaltyProvider } from "../../types/enums";
import { ILoyaltyProvider, MembershipLevel } from "./loyalty-provider.interface";
import {
    IAddDiscountToOrder, IBatchRedemptionProcess, IFetchGiftCardsBalance,
    IFetchGiftCards, IGetActiveDiscountBasket, IGetStoreLoyaltyConfigurationInfo,
    ILoyaltyData_Item, IRemoveDiscountFromOrder, ICreateFinishOrderPayloadLoyaltyResult
} from "../loyalty-service.interface";
import { DialogCreators } from "../../utils/dialog-creators";
import { ISignIn, ISignInPhone, ISignInResponse, ISignInSSO } from "../profile-service.interface";
import { IUserLoyaltyReward } from "../../models/user.interface";
import { Util } from "../../utils/util";
import { LoyaltyService } from "../loyalty-service";
import { IDataReward } from "../../models/data.interface";
import { IProfile } from "../profile.interfaces";
import { IGiftCard } from "../../todo/gift-cards.interface"
import { ITempIncompleteDiscount } from "../../interfaces/temp.interface";
import { IOrderCoupon, IOrderGiftCard } from "../../models/order.interface";
import { IApplyCouponByIdParamsPartial } from "../../models/coupons.interface";
import { Data } from "../../models/data";
import { Order } from "../../models/order";
import { User } from "../../models/user";
import { Context } from "../../models/context";
import { LocalizationService } from "../localization-service";
import { DataLayerService } from "../data-layer-service";

export class PunchhProvider implements ILoyaltyProvider {
    private readonly _data: Data;
    private readonly _context: Context;
    private readonly _localizationService: LocalizationService;
    private readonly _user: User;
    private readonly _order: Order;

    private _loyaltyProvider: LoyaltyProvider = LoyaltyProvider.PUNCHH;
    private _loyaltyService: LoyaltyService;
    private readonly _dataLayerService: DataLayerService;

    private _phoneFormatLanguage: string;
    private _hasPointRedemption: boolean = false;
    private _hasRewardRedemption: boolean = false;
    private _hasMembershipTiers: boolean = false;
    private _hasBankedCurrency: boolean = false;
    private _hasDiscountCodes: boolean = false;
    private _hasSingleSignOn: boolean = false;
    private _punchhIsDown: boolean = false;
    private _metaData: any = {};
    private _activeBasket: { discount_basket_item_id: string, discount_type: string, discount_id: string | null, discount_amount: number | null, applied: boolean }[] = [];

    constructor(data: Data, context: Context, localizationService: LocalizationService, user: User, order: Order, loyaltyService: LoyaltyService, dataLayerService: DataLayerService) {
        this._data = data;
        this._context = context;
        this._localizationService = localizationService;
        this._user = user;
        this._order = order;
        this._loyaltyService = loyaltyService;
        this._dataLayerService = dataLayerService;
        this._phoneFormatLanguage = Util.getDefaultCultureCode(this._user.user?.CountryCodeId || this._data.getProperty("StoreInfo")?.countryId || 1, this._data.getProperty("Countries") || []);
        this.setPrograms();
    }

    public setPrograms(): void {
        this._hasPointRedemption = false;
        this._hasRewardRedemption = true;
        this._hasMembershipTiers = true;
        this._hasBankedCurrency = true;
        this._hasDiscountCodes = false;
        this._hasSingleSignOn = true;

        //if (this._metaData && this._metaData.program_meta.data.program_type == "points" && this._metaData.program_meta.data.points_conversion_type == "currency")
        //this._hasBankedCurrency = true;
    }

    hasPointRedemption(): boolean {
        return this._hasPointRedemption;
    }

    hasRewardRedemption(): boolean {
        return this._hasRewardRedemption;
    }

    hasMembershipTiers(): boolean {
        return this._hasMembershipTiers;
    }

    hasBankedCurrency(): boolean {
        return this._hasBankedCurrency;
    }

    hasDiscountCodes(): boolean {
        return this._hasDiscountCodes;
    }

    hasSingleSignOn(): boolean {
        return this._hasSingleSignOn;
    }

    onlyOneDiscountAllowed = (rewardId: number | null): boolean => {
        if (rewardId == null)
            rewardId = -1;

        //if (!this._onlyOneDiscountAllowed)
        //    return false;

        if (this._order.getProperty("Coupons")?.length) {
            DialogCreators.messageBoxOk(
                this._localizationService,
                this._dataLayerService,
                this._localizationService.names("OnlyOneDiscountAllowedAtATimeError"),
                true
            );
            return true;
        }

        if (this._activeBasket.length > 0 && !this._activeBasket.map(x => Number(x.discount_id)).includes(rewardId)) {
            DialogCreators.messageBoxOk(
                this._localizationService,
                this._dataLayerService,
                this._localizationService.names("OnlyOneDiscountAllowedAtATimeError"),
                true
            );
            return true;
        }

        //if (this._aOLO.Temp.IncompleteDiscounts.length > 0 && !this._aOLO.Temp.IncompleteDiscounts.map(x => x.rewardId).includes(rewardId)) {
        //    DialogCreators.messageBoxOk(Names("OnlyOneDiscountAllowedAtATimeError"), this._context.getProperty("buttonHoverStyle"));
        //    return true;
        //}

        return false;
    }

    discountValidForOrderTime(expiryDate: string | null): boolean {
        return true;
    }

    private _setPunchhDown = async (timeout: boolean, messageId: number = 1): Promise<void> => {
        if (!timeout)
            return;

        switch (messageId) {
            case 1:
                this._punchhIsDownErrorMessage();
                break;
            case 2:
                DialogCreators.messageBoxOk(
                    this._localizationService,
                    this._dataLayerService,
                    this._localizationService.names("LoyaltyCantReachInfoError"),
                    true
                );
                break;
        }
        this._punchhIsDown = true;

        setTimeout(() => {
            this._punchhIsDown = false;
        }, 300000);
    }

    private _punchhIsDownErrorMessage() {
        DialogCreators.messageBoxOk(
            this._localizationService,
            this._dataLayerService,
            this._localizationService.names("LoyaltyServerOffline"),
            true
        );
    }

    isLoyaltyDown(): boolean {
        return this._punchhIsDown;
    }

    getLoyaltyProvider(): LoyaltyProvider {
        return this._loyaltyProvider;
    }

    getStartupInfo = async (): Promise<void> => {
        if (this.isLoyaltyDown())
            return;

        const payload: IGetStoreLoyaltyConfigurationInfo = {
            store_key: this._data.getProperty("StoreInfo")?.storeKey || "",
            data: {
                location: "olo",
                program_meta_eTag: "",
                locations_eTag: ""
            }
        };

        const response = await this._loyaltyService.getStoreLoyaltyConfigurationInfo(payload);
        if (response.success && response.data) {
            this._metaData = JSON.parse(response.data);
            this.setPrograms();
        } else if (response.timeout) {
            await this._setPunchhDown(response.timeout);
        } else if (response.message)
            DialogCreators.messageBoxOk(
                this._localizationService,
                this._dataLayerService,
                response.message,
                true
            );
    }

    public readonly signIn = async (data: ISignIn): Promise<ISignInResponse> => {
        if (this.isLoyaltyDown()) {
            this._punchhIsDownErrorMessage();
            return { success: false, timeout: true };
        }

        const response = await this._loyaltyService.signIn(data);

        if (response.timeout)
            await this._setPunchhDown(response.timeout);

        return response;
    }

    public readonly signInJWT = async (): Promise<ISignInResponse> => {
        if (this.isLoyaltyDown())
            return { success: false, timeout: true };

        const response = await this._loyaltyService.signInJWT();
        if (response.timeout)
            await this._setPunchhDown(response.timeout, 0);
        return response;
    }

    public readonly signInSSO = async (data: ISignInSSO): Promise<ISignInResponse> => {
        if (this.isLoyaltyDown()) {
            this._punchhIsDownErrorMessage();
            return { success: false, timeout: true };
        }

        const response = await this._loyaltyService.signInSSO(data);

        if (response.timeout)
            await this._setPunchhDown(response.timeout);

        this._context.setProperty("singleSignOnToken", undefined);

        return response;
    }

    public readonly signInApp = (token: string): Promise<ISignInResponse> => {
        throw new Error("Method not implemented.");
    }

    public readonly signInPhone = async (data: ISignInPhone): Promise<ISignInResponse> => {
        return { success: false, timeout: false };
    }

    getActiveDiscountBasket = async (): Promise<void> => {
        if (this.isLoyaltyDown())
            return;

        const payload: IGetActiveDiscountBasket = {
            store_key: this._data.getProperty("StoreInfo")?.storeKey || "",
            data: {
                location: "olo"
            }
        };

        const response = await this._loyaltyService.getActiveDiscountBasket(payload);
        if (response.success && response.data)
            this._addItemsToBasket(response.data);
        else {
            if (response.timeout) {
                await this._setPunchhDown(response.timeout, 0);
                return;
            }

            if (response.message?.includes("no_active_basket"))
                return;
            else
                DialogCreators.messageBoxOk(
                    this._localizationService,
                    this._dataLayerService,
                    `${this._localizationService.names("SomethingWentWrong")}<br>${
                        response.message ?? ""
                    }`,
                    true
                );
        }
    }

    public readonly addReward = async (reward: IUserLoyaltyReward): Promise<void> => {
        if (this.isLoyaltyDown() || this.onlyOneDiscountAllowed(reward.RewardId) || !this.discountValidForOrderTime(reward.ExpiryDate)) {
            return;
        }

        if (this._activeBasket.map(x => Number(x.discount_id)).includes(reward.RewardId)) {
            await this.batchComparison(true);
            return;
        }

        const payload: IAddDiscountToOrder = {
            store_key: this._data.getProperty("StoreInfo")?.storeKey || "",
            data: {
                user_id: Number(this._user.user?.LoyaltyReferenceID),
                external_uid: this._order.getProperty("GUID") || "",
                location: "olo",
                discount_basket_items_attributes: [
                    {
                        discount_type: "reward",
                        discount_id: String(reward.RewardId)
                    }
                ]
            }
        };

        const response = await this._loyaltyService.addDiscountToOrder(payload);
        if (response.success && response.data) {
            this._addItemsToBasket(response.data);
            if (this._order.getProperty("Items")?.length)
                await this.batchComparison(true);
        } else {
            if (response.timeout)
                await this._setPunchhDown(response.timeout, 2);
            else
                DialogCreators.messageBoxOk(
                    this._localizationService,
                    this._dataLayerService,
                    `${this._localizationService.names("SomethingWentWrong")}<br>${
                        response.message ?? ""
                    }`,
                    true
                );
        }
    }

    private _addItemsToBasket = (data: string): void => {
        if (!data)
            return;

        const jData = JSON.parse(data);
        for (const item of jData.discount_basket_items) {
            if (!this._activeBasket.map(x => x.discount_basket_item_id).includes(item.discount_basket_item_id))
                switch (item.discount_type) {
                    case "reward":
                        this._activeBasket.push({ discount_basket_item_id: String(item.discount_basket_item_id), discount_type: item.discount_type, discount_id: item.discount_id, discount_amount: null, applied: false });
                        break;
                    case "discount_amount":
                        this._activeBasket.push({ discount_basket_item_id: String(item.discount_basket_item_id), discount_type: item.discount_type, discount_id: null, discount_amount: item.discount_value, applied: false });
                        break;
                }

            if (item.discount_id)
                this._addRewardToIncompleteDiscounts(Number(item.discount_id));
            else
                this._addBankedCurrencyToIncompleteDiscounts();
        }
    }

    /**
     * Removes the reward from the basket and updates the order.
     * @param reward
     * @returns {boolean} - Indicates if the cart should be updated
     */
    removeReward = async (reward: IUserLoyaltyReward): Promise<boolean> => {
        if (this.isLoyaltyDown())
            return false;

        const basketItem = this._activeBasket.find(x => Number(x.discount_id) == reward.RewardId);
        if (!basketItem)
            return false;

        const payload: IRemoveDiscountFromOrder = {
            store_key: this._data.getProperty("StoreInfo")?.storeKey || "",
            data: {
                user_id: Number(this._user.getProperty("LoyaltyReferenceID")),
                external_uid: this._order.getProperty("GUID") || "",
                location: "olo",
                order_guid: this._order.getProperty("GUID") || "",
                discount_basket_item_ids: [String(basketItem.discount_basket_item_id)]
            }
        };

        const response = await this._loyaltyService.removeDiscountFromOrder(payload);
        if (response.success || response.timeout) {
            reward.Used = false;
            this._activeBasket = this._activeBasket.filter(x => x.discount_id !== basketItem.discount_id);

            const coupon = this._order.getProperty("Coupons")?.find(x => x.RewardId == reward.RewardId);
            if (coupon)
                await this._order.removeCouponByKeyAsync(this, coupon.CouponKey, true, true);

            //const index = this._aOLO.Temp.IncompleteDiscounts.findIndex(x => x.rewardId === reward.RewardId);
            //if (index > -1) {
            //    this._aOLO.Temp.IncompleteDiscounts.splice(index, 1);
            //}
            //OnlineOrderingUtil.GUI_SetOrder_Total(false, this._aOLO, aOLOModules);
        } else
            DialogCreators.messageBoxOk(
                this._localizationService,
                this._dataLayerService,
                `${this._localizationService.names("SomethingWentWrong")}<br>${
                    response.message ?? ""
                }`,
                true
            );

        return true;
    }

    private removePunchhDiscount = async (basketItemId: string): Promise<void> => {
        if (this.isLoyaltyDown())
            return;

        const basketItem = this._activeBasket.find(x => x.discount_basket_item_id === basketItemId);
        if (!basketItem)
            return;

        const payload: IRemoveDiscountFromOrder = {
            store_key: this._data.getProperty("StoreInfo")?.storeKey || "",
            data: {
                user_id: Number(this._user.getProperty("LoyaltyReferenceID")),
                location: "olo",
                external_uid: this._order.getProperty("GUID") || "",
                order_guid: this._order.getProperty("GUID") || "",
                discount_basket_item_ids: [basketItem.discount_basket_item_id]
            }
        };

        const response = await this._loyaltyService.removeDiscountFromOrder(payload);
        //if (response.success || response.timeout) {
        //    this._activeBasket = this._activeBasket.filter(x => x.discount_basket_item_id !== basketItem.discount_basket_item_id);
        //    OnlineOrderingUtil.GUI_SetOrder_Total(false, this._aOLO, aOLOModules);
        //} else
        //    DialogCreators.messageBoxOk(`${Names("SomethingWentWrong")}<br>${response.message || ""}`, this._context.getProperty("buttonHoverStyle"));
    }

    getAppliedBankedCurrency = (): number => {
        const applied = this._activeBasket.find(x => x.discount_id == null && x.applied);
        if (!applied)
            return 0;

        return applied.discount_amount || 0;
    }

    applyBankedCurrency = async (currencyToApply: number): Promise<void> => {
        if (this.isLoyaltyDown() || this.onlyOneDiscountAllowed(null)) {
            return;
        }

        const payload: IAddDiscountToOrder = {
            store_key: this._data.getProperty("StoreInfo")?.storeKey || "",
            data: {
                user_id: Number(this._user.user?.LoyaltyReferenceID),
                location: "olo",
                external_uid: this._order.getProperty("GUID") || "",
                discount_basket_items_attributes: [
                    {
                        discount_type: "discount_amount",
                        discount_value: currencyToApply
                    }
                ]
            }
        };

        const response = await this._loyaltyService.addDiscountToOrder(payload);
        if (response.success && response.data) {
            this._addItemsToBasket(response.data);
            if (this._order.getProperty("Items")?.length)
                await this.batchComparison(true);
        } else {
            if (response.timeout)
                await this._setPunchhDown(response.timeout);
            else
                DialogCreators.messageBoxOk(
                    this._localizationService,
                    this._dataLayerService,
                    `${this._localizationService.names("SomethingWentWrong")}<br>${
                        response.message ?? ""
                    }`,
                    true
                );
        }
    }

    removeBankedCurrency = async (): Promise<void> => {
        if (this.isLoyaltyDown())
            return;

        const currencyItem = this._activeBasket.find(x => x.discount_id == null);
        if (!currencyItem)
            return;

        const payload: IRemoveDiscountFromOrder = {
            store_key: this._data.getProperty("StoreInfo")?.storeKey || "",
            data: {
                user_id: Number(this._user.user?.LoyaltyReferenceID),
                location: "olo",
                external_uid: this._order.getProperty("GUID") || "",
                order_guid: this._order.getProperty("GUID") || "",
                discount_basket_item_ids: [String(currencyItem.discount_basket_item_id)]
            }
        };

        const response = await this._loyaltyService.removeDiscountFromOrder(payload);
        if ((response.success && response.data) || response.timeout) {
            this._activeBasket = this._activeBasket.filter(x => x.discount_id !== null);
            const coupon = this._order.getProperty("Coupons")?.find(x => x.IsBankedCurrency);
            if (coupon)
                await this._order.removeCouponByKeyAsync(this, coupon.CouponKey, true, true);

            //const index = this._aOLO.Temp.IncompleteDiscounts.findIndex(x => x.isBankedCurrency);
            //if (index > -1) {
            //    this._aOLO.Temp.IncompleteDiscounts.splice(index, 1);
            //}

            // Refactor: OnlineOrderingUtil.GUI_SetOrder_Total(false, globalThis.aOLO, aOLOModules);
        } else
            DialogCreators.messageBoxOk(
                this._localizationService,
                this._dataLayerService,
                response.message ?? "",
                true
            );
    }

    private _addRewardToIncompleteDiscounts = (rewardId: number): void => {
        const reward = this._user.user?.LoyaltyData?.Rewards.find(x => x.RewardId == rewardId);

        if (!reward)// || this._aOLO.Temp.IncompleteDiscounts.find(x => x.rewardId == rewardId))
            return;

        reward.Used = true;

        const incompleteCoupon: ITempIncompleteDiscount = {
            couponID: 10,
            rewardId: rewardId
        };
        //this._aOLO.Temp.IncompleteDiscounts.push(incompleteCoupon);
    }

    private _addBankedCurrencyToIncompleteDiscounts = (): void => {
        //if (this._aOLO.Temp.IncompleteDiscounts.find(x => x.isBankedCurrency))
        //    return;

        //const incompleteCoupon: ITempIncompleteDiscount = {
        //    couponID: 11,
        //    isBankedCurrency: true
        //};
        //this._aOLO.Temp.IncompleteDiscounts.push(incompleteCoupon);
    }

    private formatToISO8601(date: Date): string {
        // Get the timezone offset in minutes and convert it to hours and minutes
        const offset = -date.getTimezoneOffset();
        const offsetHours = Math.floor(Math.abs(offset) / 60);
        const offsetMinutes = Math.abs(offset) % 60;

        // Format the offset as a string "+hh:mm" or "-hh:mm"
        const offsetSign = offset >= 0 ? '+' : '-';
        const formattedOffset = `${offsetSign}${offsetHours.toString().padStart(2, '0')}:${offsetMinutes.toString().padStart(2, '0')}`;

        // Convert date to ISO string and replace 'Z' with the timezone offset
        return date.toISOString().replace('Z', formattedOffset);
    }

    batchComparison = async (query: boolean, remove: boolean = false): Promise<boolean> => {
        if (this.isLoyaltyDown()) {
            this._punchhIsDownErrorMessage();
            return false;
        }

        if ((this._activeBasket.length == 0 || this._order.getProperty("Items")?.length == 0) &&
            (!(this._user.getProperty("LoyaltyData")?.Rewards.filter(x => x.Used).length == 0 && this._order.getProperty("Coupons")?.filter(x => [10, 11].includes(x.CouponId)).length == 0)))
            return true;

        const discount = (this._order.getProperty("Discount") || 0) - (this._order.getProperty("Coupons")?.reduce((accumulator: number, coupon: IOrderCoupon) => {
            return accumulator + ([10, 11].includes(coupon.CouponId) ? coupon.Amount : 0);
        }, 0) || 0);

        const payload: IBatchRedemptionProcess = {
            store_key: this._data.getProperty("StoreInfo")?.storeKey || "",
            data: {
                location: "olo",
                query: query,
                store_number: Number(this._data.getProperty("StoreInfo")?.storeCode),
                user_id: Number(this._user.user?.LoyaltyReferenceID),
                order_guid: this._order.getProperty("GUID") || "",
                transaction_no: (query ? this._order.getProperty("GUID") : this._order.getProperty("OrderID")?.toString()) || "",
                receipt_datetime: this.formatToISO8601((query ? this._order.getProperty("OrderStartTime") : this._order.getProperty("OrderEndTime")) || new Date()),
                subtotal_amount: Number((this._order.getProperty("SubTotal") || 0 - discount).toFixed(2)),
                receipt_amount: Number((this._order.getProperty("SubTotal") || 0 - discount).toFixed(2)),
                line_items: []
            }
        };

        let halfCount = 1;
        let itemCount = 0;
        let lastItemKey = -1;

        // Menu Items
        for (const item of this._order.getProperty("Items") || []) {
            if (item.ItemKey != lastItemKey) {
                lastItemKey = item.ItemKey;
                halfCount = 1;
                itemCount++;
            }

            const itemName = this._localizationService.GetName(this._data.getProperty("Items")?.[item.Index].Names || []);

            if (item.HalfCount > 1) {
                if (halfCount == 1) {
                    const halfHalfPayload: ILoyaltyData_Item = {
                        item_id: 0,
                        item_name: itemName,
                        item_qty: item.Quantity,
                        amount: (item.HalfHalfPrice * item.Quantity),
                        item_type: "M",
                        item_family: "0",
                        item_group: `${item.ItemCategoryId}`,
                        index: `${itemCount}.0`
                    };
                    payload.data.line_items.push(halfHalfPayload);

                    const itemPayload: ILoyaltyData_Item = {
                        item_id: item.ItemId,
                        item_name: itemName,
                        item_qty: item.Quantity,
                        amount: 0,//(item.Price * item.Quantity),
                        item_type: "M",
                        item_family: item.SizeId.toString(),
                        item_group: `${item.ItemCategoryId}`,
                        index: `${itemCount}.1`
                    };
                    payload.data.line_items.push(itemPayload);
                } else {
                    const itemPayload: ILoyaltyData_Item = {
                        item_id: item.ItemId,
                        item_name: itemName,
                        item_qty: item.Quantity,
                        amount: 0, //(item.Price * item.Quantity),
                        item_type: "M",
                        item_family: item.SizeId.toString(),
                        item_group: `${item.ItemCategoryId}`,
                        index: `${itemCount}.${halfCount}`
                    };
                    payload.data.line_items.push(itemPayload);
                }
                halfCount++;
            } else {
                let modifierTotalPrice = 0;
                if (item.Modifiers) {
                    for (const mod of item.Modifiers) {
                        modifierTotalPrice += mod.Price;
                    }
                }

                const itemPayload: ILoyaltyData_Item = {
                    item_id: item.ItemId,
                    item_name: itemName,
                    item_qty: item.Quantity,
                    amount: (item.Price * item.Quantity) + -modifierTotalPrice,
                    item_type: "M",
                    item_family: item.SizeId.toString(),
                    item_group: `${item.ItemCategoryId}`,
                    index: `${itemCount}.0`
                };
                payload.data.line_items.push(itemPayload);

                // Modifiers
                if (item.Modifiers) {
                    for (const [index, mod] of item.Modifiers.entries()) {
                        const modifier: ILoyaltyData_Item = {
                            item_id: mod.ModifierId,
                            item_name: itemName,
                            item_qty: 1,
                            amount: mod.Price,
                            item_type: "M",
                            item_family: "",
                            item_group: "", //`${mod.CategoryID}`,
                            index: `${itemCount}.${index + 1}`
                        };
                        payload.data.line_items.push(modifier);
                    }
                }
                itemCount++;
            }
        }

        for (const item of this._order.getProperty("Coupons")?.filter(x => ![10, 11].includes(x.CouponId)) || []) {
            const mCoupon = this._order.getCoupon(item.CouponId, true, this._order.getProperty("OrderTypeID"), null);
            const coupon: ILoyaltyData_Item = {
                item_id: item.CouponKey,
                item_name: this._localizationService.GetName(mCoupon?.Names || []),
                item_qty: 1,
                amount: item.Discount,
                item_type: "D",
                item_family: "",
                item_group: "",
                index: `${itemCount}.0`
            };
            payload.data.line_items.push(coupon);
        }

        const response = await this._loyaltyService.batchRedemptionProcess(payload);
        if (response.success && response.data) {
            const jData = JSON.parse(response.data);
            for (const discount of jData.failures) {
                const reward = this._user.getProperty("LoyaltyData")?.Rewards.find((x: IUserLoyaltyReward) => x.RewardId == Number(discount.discount_id));
                if (!reward) {
                    await this.removePunchhDiscount(String(discount.discount_basket_item_id));
                    continue;
                }

                const discountBasket = this._activeBasket.find(x => x.discount_basket_item_id == String(discount.discount_basket_item_id));
                if (discountBasket) {
                    discountBasket.discount_id = discount.discount_id;
                    discountBasket.applied = false;
                }

                this._addRewardToIncompleteDiscounts(Number(discount.discount_id));

                if (remove)
                    await this.removeReward(reward);
                else {
                    const coupon = this._order.getProperty("Coupons")?.find(x => x.RewardId == reward.RewardId);
                    if (coupon)
                        await this._order.removeCouponByKeyAsync(this, coupon.CouponKey, true, true);
                }
            }
            for (const discount of jData.success) {
                const basketCoupon = this._activeBasket.find(x => x.discount_basket_item_id === String(discount.discount_basket_item_id));
                const amount = discount.discount_type == "discount_amount" ? discount.discount_value : discount.discount_amount;

                if (basketCoupon) {
                    if (basketCoupon.applied && basketCoupon.discount_amount == amount)
                        continue;

                    basketCoupon.discount_id = discount.discount_id;

                    const rewardId = basketCoupon.discount_id ? Number(basketCoupon.discount_id) : null;
                    const isBankedCurrency = (discount.discount_type == "discount_amount");
                    const couponId = !isBankedCurrency ? 10 : 11;

                    // If coupon already applied, but amount changed, remove coupon
                    if (basketCoupon.applied && basketCoupon.discount_amount != amount) {
                        let coupon: IOrderCoupon | null = null;
                        if (isBankedCurrency)
                            coupon = this._order.getProperty("Coupons")?.find((x: IOrderCoupon) => x.IsBankedCurrency) || null;
                        else if (rewardId)
                            coupon = this._order.getProperty("Coupons")?.find((x: IOrderCoupon) => x.RewardId == rewardId) || null;

                        if (coupon)
                            await this._order.removeCouponByKeyAsync(this, coupon.CouponKey, true, true);
                    }

                    basketCoupon.discount_amount = amount;

                    // Apply coupon
                    const params: IApplyCouponByIdParamsPartial = {
                        loyaltyProvider: this,
                        couponId: couponId,
                        discount: amount,
                        showErrorMsg: true,
                        rewardId: rewardId,
                        runBatch: false,
                        isBankedCurrency: isBankedCurrency,
                        couponCode: null,
                        isCampaignCode: false,
                        isPromotionCode: false,
                        channelId: null,
                        sourceId: null,
                        isSUCValidationReq: false,
                        isSpecialCode: false
                    };
                    const isApplied = await this._order.applyCouponByIdAsync(params);
                    if (!isApplied)
                        continue;

                    basketCoupon.applied = true;

                    const coupon = this._order.getProperty("Coupons").find((x: IOrderCoupon) => x.CouponId == couponId);
                    if (coupon) {
                        coupon.RedemptionReference = jData.redemption_ref;
                        coupon.BasketItemId = String(discount.discount_basket_item_id);
                    }

                    const reward = this._user.getProperty("LoyaltyData")?.Rewards.find((x: IUserLoyaltyReward) => x.RewardId == Number(discount.discount_id));
                    if (reward) {
                        reward.Used = true;
                        reward.json = JSON.stringify(discount);
                    }
                } else {
                    const rewardId = discount.discount_id ? Number(discount.discount_id) : null;
                    const isBankedCurrency = (discount.discount_type == "discount_amount");
                    const couponId = !isBankedCurrency ? CouponIdList.LOYALTY_OFFER_THIRDPARTY : CouponIdList.LOYALTY_REWARD_THIRDPARTY;
                    const params: IApplyCouponByIdParamsPartial = {
                        loyaltyProvider: this,
                        couponId: couponId,
                        discount: amount,
                        showErrorMsg: true,
                        rewardId: rewardId,
                        runBatch: false,
                        isBankedCurrency: isBankedCurrency,
                        couponCode: null,
                        isCampaignCode: false,
                        isPromotionCode: false,
                        channelId: null,
                        sourceId: null,
                        isSUCValidationReq: false,
                        isSpecialCode: false
                    };
                    const isApplied = await this._order.applyCouponByIdAsync(params);
                    if (!isApplied)
                        continue;

                    const appliedToBasket = {
                        discount_basket_item_id: String(discount.discount_basket_item_id),
                        discount_type: discount.discount_type,
                        discount_id: discount.discount_id,
                        discount_amount: amount,
                        applied: true
                    };
                    this._activeBasket.push(appliedToBasket);

                    const reward = this._user.getProperty("LoyaltyData")?.Rewards.find((x: IUserLoyaltyReward) => x.RewardId == Number(discount.discount_id));
                    if (reward) {
                        reward.Used = true;
                        reward.json = JSON.stringify(discount);
                    }
                }

                //switch (discount.discount_type) {
                //    case "reward":
                //        this._aOLO.Temp.IncompleteDiscounts = this._aOLO.Temp.IncompleteDiscounts.filter(x => x.rewardId !== Number(discount.discount_id));
                //        break;
                //    case "discount_amount":
                //        this._aOLO.Temp.IncompleteDiscounts = this._aOLO.Temp.IncompleteDiscounts.filter(x => !x.isBankedCurrency);
                //        break;
                //}
            }

            //OnlineOrderingUtil.GUI_SetOrder_Total(true, this._aOLO, aOLOModules);
            return true;
        } else if (!response.success && response.message != "No Basket found.") {
            if (response.timeout)
                await this._setPunchhDown(response.timeout);
            else
                DialogCreators.messageBoxOk(
                    this._localizationService,
                    this._dataLayerService,
                    response.message ?? "",
                    true
                );
        }
        return false;
    }

    fetchGiftCards = async (passcode: string | null): Promise<any> => {
        if (this.isLoyaltyDown())
            return false;

        const payload: IFetchGiftCards = {
            store_key: this._data.getProperty("StoreInfo")?.storeKey || "",
            data: {
                location: "olo",
                passcode: passcode
            }
        };

        const response = await this._loyaltyService.fetchGiftCards(payload);
        if (response.success && response.data) {
            const giftCards: IGiftCard[] = JSON.parse(response.data);

            let giftCardsDiv = document.getElementById("div_gift_cards");
            if (!giftCardsDiv)
                return;

            giftCardsDiv.innerHTML = "";

            if (!this._user.getProperty("LoyaltyData"))
                return;

            if (giftCards.length == 0) {
                Util.DialogFadeOut("dia_gift_cards");
                DialogCreators.messageBoxOk(
                    this._localizationService,
                    this._dataLayerService,
                    this._localizationService.names("NoAvailableGiftCards"),
                    true
                );
                return;
            }

            for (const giftCard of giftCards) {
                if (giftCardsDiv) {

                    const existingCard = this._order.getProperty("GiftCards").find(card => card.cardNo === giftCard.card_number);
                    if (existingCard)
                        giftCard.last_fetched_amount -= existingCard.appliedAmount;

                    giftCardsDiv.innerHTML += this._createGiftCardTile(giftCard);
                }
            }

            const applyBtns = Array.from(document.getElementsByName("btn_gift_card_apply"));
            for (const button of applyBtns) {
                button.onclick = async () => {

                    const giftCardID = button.dataset.gcid;
                    const card = giftCards.find(x => x.gift_card_id == giftCardID);
                    if (card)
                        this._applyGiftCard(card);

                    Util.DialogFadeOut("dia_gift_cards");
                };
            }

            return true;
        }
        else {
            if (response.timeout)
                await this._setPunchhDown(response.timeout);
            else
                DialogCreators.messageBoxOk(
                    this._localizationService,
                    this._dataLayerService,
                    response.message ?? "",
                    true
                );

            Util.DialogFadeOut("dia_gift_cards");
            return false;
        }
    }

    private _applyGiftCard = (giftCard: IGiftCard): void => {
        const rndString = (Math.floor(Math.random() * 100) + 1).toString();
        const divID = `div_checkout_applied_gift_${rndString}`;
        const maskedCardNumber = "**** " + giftCard.card_number.slice(-4);

        const card: IOrderGiftCard = {
            cardNo: giftCard.card_number,
            balance: giftCard.last_fetched_amount,
            pin: giftCard.epin,
            appliedAmount: 0,
            randomId: rndString,
            uuid: giftCard.uuid
        };

        this._order.addGiftCard(card);
        const country = this._data.getProperty("StoreInfo").country;

        const html = `
            <div id="${divID}" class="giftcard" data-card="${JSON.stringify(giftCard)}">
                <div class="giftcard_Number" aria-label="gift card number">${maskedCardNumber}</div>
                <div class="gridColsAuto1x">
                    <label class="gridCol1 giftcard_Label" for="div_checkout_gift_start_balance_${rndString}">${this._localizationService.names("StartingBalance")}</label>
                    <div id="div_checkout_gift_start_balance_${rndString}" class="gridCol2 giftcard_Amount">${Util.formatMoney(card.balance, country)}</div>
                </div>
                <div class="gridColsAuto1x">
                    <label class="gridCol1 giftcard_Label" for="div_checkout_gift_applied_amount_${rndString}">${this._localizationService.names("AppliedToOrder")}</label>
                    <div id="div_checkout_gift_applied_amount_${rndString}" class="gridCol2 giftcard_Amount">${Util.formatMoney(card.appliedAmount, country)}</div>
                </div>
                <div class="gridColsAuto1x">
                    <label class="gridCol1 giftcard_Label" for="div_checkout_gift_end_balance_${rndString}">${this._localizationService.names("EndingBalance")}</label>
                    <div id="div_checkout_gift_end_balance_${rndString}" class="gridCol2 giftcard_Amount">${Util.formatMoney(card.balance - card.appliedAmount, country)}</div>
                </div>
                <div class="giftcard_Remove">
                    <button id="btn_checkout_gift_remove_${rndString}" class="btnLink" ltag="Remove">${this._localizationService.names("Remove")}</button>
                </div>
            </div>`;

        const mainDiv = document.getElementById("div_checkout_applied_gifts");
        if (mainDiv)
            mainDiv.appendChild(Util.createHtmlElementFromTemplate(html));

        const self = this;
        Util.setElement("onclick", `btn_checkout_gift_remove_${rndString}`, () => { self._removeGiftCard(card.cardNo, divID); });
        Util.setElement("value", "txt_checkout_gift_card_number", "");
        Util.setElement("value", "txt_checkout_gift_card_pin", "");
        return;
    }

    private _removeGiftCard = (cardNo: string, divId: string): void => {
        const div = document.getElementById(divId);
        if (div)
            div.remove();

        this._order.removeGiftCard(cardNo);
    }

    fetchGiftCardsBalance = async (uuids: string[]): Promise<any> => {
        if (this.isLoyaltyDown())
            return false;

        const payload: IFetchGiftCardsBalance = {
            store_key: this._data.getProperty("StoreInfo")?.storeKey || "",
            data: {
                location: "olo",
                uuids: uuids
            }
        };

        const response = await this._loyaltyService.fetchGiftCardsBalance(payload);
        if (response.success) {
            return true;
        } else {
            if (response.timeout)
                await this._setPunchhDown(response.timeout);
            else
                DialogCreators.messageBoxOk(
                    this._localizationService,
                    this._dataLayerService,
                    response.message ?? "",
                    true
                );

            return false;
        }
    }

    /**
     * Creates the HTML for a reward tile.
     * @private
     * @param {Object} item - The reward data object.
     * @return {string} The HTML for the reward tile.
     */
    private _createRewardTile = (reward: IUserLoyaltyReward): string => {
        const languageCode = this._context.getProperty("languageCode");
        const redeemText = reward.Used ? "Void" : "Redeem";

        let html = `
            <div class="reward m1-t gridCols1xAuto_resp">
                <span class="bold gridCol1" ltagj='${Util.toLtagj(reward.Names)}'>${this._localizationService.GetName(reward.Names)}</span>
                <div class="gridCol2 right">
                    ${(reward.ExpiryDate != null) ? `<span ltag="Expires" class="fontSmaller">${this._localizationService.names("Expires")}</span> <span>${new Date(reward.ExpiryDate).toLocaleDateString(languageCode)}</span>` : ``}<br />
                    <button id="btn_loyalty_reward_redeem_${reward.RewardId}" name="btn_loyalty_reward_redeem" data-rid="${reward.RewardId}" class="btnLink m0" ltag="${redeemText}">${this._localizationService.names(redeemText)}</button>
                </div>
            </div>`;

        return html;
    }

    /**
     * Renders the rewards list on the loyalty summary page.
     * @public
     * @returns {void}
     */
    public renderRewardsList = (closeDialogFunction: Function): void => {
        const currentPoints = this._user.getProperty("LoyaltyData")?.EarnedPoints || 0;
        let rewCnt = this._getRewardsCount();
        Util.setElement("innerHTML", "spn_loyalty_rewards", `(${rewCnt})`);

        if (this._user.getProperty("CustomerId") !== 0 && currentPoints !== 0) {
            Util.hideElement("div_loyalty_rewards_has_rewards");
            Util.showElement("div_loyalty_existing_rewards");
            Util.hideElement("div_loyalty_rewards_no_rewards");

            const pointsToNextReward = this._calculatePointsToNextReward();
            if (pointsToNextReward)
                Util.showElement("div_loyalty_rewards");

            this._loadRewards(closeDialogFunction);
        } else {
            Util.hideElement("div_loyalty_rewards_has_rewards");
            Util.hideElement("div_loyalty_existing_rewards");
            Util.showElement("div_loyalty_rewards_no_rewards");
        }
    }

    private _calculatePointsToNextReward(): number {
        let points = 9999;
        const pointConversionThreshold = this._getPointConversionThreshold();
        if (this._user.getProperty("LoyaltyData")) {
            points = pointConversionThreshold - ((this._user.getProperty("LoyaltyData")?.EarnedPoints || 0) % pointConversionThreshold);
        }
        return points;
    }

    private _getPointConversionThreshold(): number {
        return this._metaData.points_conversion_threshold;
    }

    /**
     * Loads the rewards data and creates the HTML for the existing rewards section.
     * @private
     * @return {void}
     */
    private _loadRewards = (closeDialogFunction: Function): void => {
        let rewardsDiv = document.getElementById("div_loyalty_existing_rewards");
        if (!rewardsDiv)
            return;

        rewardsDiv.innerHTML = "";

        const loyaltyData = this._user.getProperty("LoyaltyData");
        if (!loyaltyData)
            return;

        loyaltyData.Rewards.forEach(reward => {
            if (rewardsDiv && !reward.Expired)
                rewardsDiv.innerHTML += this._createRewardTile(reward);
        });

        const redeemBtns = Array.from(document.getElementsByName("btn_loyalty_reward_redeem"));
        for (const button of redeemBtns) {
            button.onclick = async () => {
                // 2DO: Might not need this
                // if (!aOLO.isBrandSignIn) {
                //     //2DO: Refactor reward redemption
                //     //await Common.redeemRewardOnClick(Number(button.dataset.rid), aOLO.User.LoyaltyData);
                //     closeDialogFunction();
                // }
            };
        }
    }

    /**
     * Gets the count of rewards that the user has earned.
     * @private
     * @returns {number} The count of rewards that the user has earned.
     */
    private _getRewardsCount = (): number => {
        return this._user.getProperty("LoyaltyData")?.Rewards.length || 0;
    }

    /**
     * Creates the HTML for a Gift card tile.
     * @private
     * @param {Object} item - The reward data object.
     * @return {string} The HTML for the reward tile.
     */
    private _createGiftCardTile = (giftCard: IGiftCard): string => {
        // Extract last 4 digits of the card number and replace the rest with *
        const maskedCardNumber = "**** " + giftCard.card_number.slice(-4);
        const formattedAmount = giftCard.last_fetched_amount.toFixed(2);

        // Construct the HTML for the "Apply" button only if last_fetched_amount is greater than 0
        const applyButtonHtml = giftCard.last_fetched_amount > 0 ?
            `<div class="gridCol2 right">
            <button name="btn_gift_card_apply" id="btn_gift_card_apply_${giftCard.gift_card_id}" ltagj="Apply" data-gcid="${giftCard.gift_card_id}">${this._localizationService.names("Apply")}</button>
        </div>` :
            '';

        let html = `
        <div class="gift_card m1-t gridCols1xAuto_resp">
            <div>
                ${this._localizationService.names("Number")}: <span class="bold gridCol1" >${maskedCardNumber}</span>
            </div>
            <br>
            <div>
                ${this._localizationService.names("Balance")}: <span> $${formattedAmount}</span>
            </div>
            ${applyButtonHtml}
            
        </div>`;

        return html;
    }

    public renderUserLoyaltyBalance(): void {
        const loyaltyData = this._user.getProperty("LoyaltyData");
        if (!loyaltyData)
            return;

        Util.hideElement("div_loyalty_not_joined");
        Util.hideElement("div_loyalty_last_trans_date");
        Util.hideElement("div_loyalty_points_last_updated_date");
        Util.hideElement("div_loyalty_points_title");
        Util.hideElement("div_loyalty_lifetime_points");

        Util.setElement("innerHTML", "spn_loyalty_banked_currency", Util.formatMoney(Number(loyaltyData.BankedCurrency), this._data.getProperty("StoreInfo").country));
        Util.showElement("div_loyalty_banked_currency");

        Util.setElement("innerHTML", "spn_loyalty_joined_date", (loyaltyData.LoyaltyJoinedDate ? Util.formatDate(new Date(loyaltyData.LoyaltyJoinedDate)) : "n/a"));
        Util.setElement("innerHTML", "spn_loyalty_points", loyaltyData.CurrentPoints.toString());
    }

    /**
     * Renders the membership list on the loyalty summary page.
     * @public
     * @returns {void}
     */
    public renderMembershipList = (): void => {
        const loyaltyData = this._user.getProperty("LoyaltyData");
        const currentPoints = loyaltyData?.EarnedPoints || 0;
        const currentTierName = loyaltyData?.TierName || "";

        Util.setElement("innerHTML", "spn_loyalty_membership", ` ${currentTierName}`);
        //Util.setElement("ltagj", "spn_loyalty_membership", (currentTier ? Util.toLtagj(currentTier.Names) : ""));

        // if (aOLO.User) {
        Util.hideElement("div_loyalty_membership_has_membership");
        Util.hideElement("div_loyalty_membership_no_membership");

        const currentMembershipLevel = this._getCurrentMembershipLevel();
        if (currentMembershipLevel) {
            const image = `<img class="loyalty-icon-image" alt="membership icon" src="${currentMembershipLevel.background_image_url}" />`;
            Util.setElement("innerHTML", "div_loyalty_membership_icon", image);
            Util.showElement("div_loyalty_membership");
        }

        const nextMembershipLevel = this._getNextMembershipLevel();
        if (nextMembershipLevel != null) {
            Util.setElement("innerHTML", "spn_loyalty_membership_next_name", ` ${nextMembershipLevel.name}`);
            Util.setElement("innerHTML", "spn_loyalty_membership_points_needed", `${nextMembershipLevel.minimum_points - currentPoints} `);
            Util.setElement("innerHTML", "spn_loyalty_membership_bar_points", `${currentPoints}`);
            Util.setElement("innerHTML", "spn_loyalty_membership_next_bar_points", `${nextMembershipLevel.minimum_points}`);
            let widthDiv = document.getElementById("div_loyalty_membership_bar_points_width");
            if (widthDiv) {
                let width = Math.round((currentPoints / nextMembershipLevel.maximum_points) * 100);
                widthDiv.style.width = (width > 100 ? 100 : width) + "%";
            }
            Util.showElement("div_loyalty_membership_has_membership");
        }
        // }
        // else {
        //     Util.hideElement("div_loyalty_membership_has_membership");
        //     Util.showElement("div_loyalty_membership_no_membership");
        // }
    }

    private _getNextMembershipLevel(): MembershipLevel | null {
        const currentPoints = this._user.getProperty("LoyaltyData")?.EarnedPoints || 0;
        const membershipLevels: MembershipLevel[] = this._metaData.membership_levels;
        const membershipsGreaterThan = membershipLevels.filter(x => x.minimum_points > currentPoints);

        let nextMembershipLevel: MembershipLevel | null = null;
        if (membershipsGreaterThan.length > 0) {
            nextMembershipLevel = membershipsGreaterThan[0];
        }
        return nextMembershipLevel;
    }

    private _getCurrentMembershipLevel(): MembershipLevel | undefined {
        const tierId = this._user.getProperty("LoyaltyData")?.TierId;
        const membershipLevels: MembershipLevel[] = this._metaData.membership_levels;
        let currentMembershipLevel = membershipLevels.find(x => x.membership_level_id == tierId);
        return currentMembershipLevel;
    }

    renderSurveyOffersList(closeDialogFunction: Function, brandFunction: Function | null): void {
        Util.hideElement("div_loyalty_offers");
        return;
    }

    setIncompleteReward(rewardId: number | null): void {
        const rewardInBasket = this._activeBasket.find(x => x.discount_id === rewardId?.toString());
        if (!rewardInBasket)
            return;

        rewardInBasket.applied = false;
    }

    public setProfileValues = (profile: IProfile, isSignUp: boolean, monthOnClickFunction: Function, signUpFunction: Function, updateProfileFunction: Function,
        renderAddressListFunction: Function, setUserAllergiesFunction: Function, setUserDietaryFunction: Function, deleteProfileFunction: Function): void => {
        let header = document.getElementById("h2_profile_header");
        let btn = document.getElementById("btn_profile_profile");
        let btnDelete = document.getElementById("btn_profile_delete");

        if (this._user.getProperty("IsBlocked"))
            Util.hideElement("div_profile_join_loyalty");
        else {
            Util.showElement("div_profile_join_loyalty");
            const isLoyalty = this._user.getProperty("IsLoyalty");
            profile.IsLoyalty = isLoyalty != null ? isLoyalty : true;
        }

        monthOnClickFunction();

        Util.hideElement("div_profile_age_13");
        Util.setElementClass("remove", "div_profile", "condensed");

        const allergies = document.getElementById("div_profile_allergies");
        const dietary = document.getElementById("div_profile_dietary");

        if (profile.ProfileId != 0) {
            Util.showElement("div_profile_delete");
            Util.hideElement("div_profile_password1");
            Util.hideElement("div_profile_password2");
            Util.hideElement("div_profile_terms_privacy_policy");
            Util.showElement("div_profile_addresses")
            //Util.showElement("div_profile_wallet")

            if (header) {
                header.innerText = this._localizationService.names("Profile");
                header.setAttribute("ltag", "Profile");
            }
            if (btnDelete) {
                btnDelete.innerText = this._localizationService.names("UpdateMyProfile");
                btnDelete.setAttribute("ltag", "UpdateMyProfile");
                btnDelete.onclick = function () {
                    deleteProfileFunction();
                };
            }
            if (btn) {
                btn.innerText = this._localizationService.names("UpdateMyProfile");
                btn.setAttribute("ltag", "UpdateMyProfile");
                btn.onclick = function () { updateProfileFunction() };
            }

            Util.setElement("disabled", "txt_profile_mark_promo_text", !profile.IsMarketingText);

            if (profile.Addresses?.length > 0) {
                Util.showElement("div_profile_all_addresses");
                Util.hideElement("spn_profile_addresses")
                renderAddressListFunction()
            } else {
                Util.hideElement("div_profile_all_addresses")
                Util.showElement("spn_profile_addresses");
            }

            if (profile.IsLoyalty)
                Util.hideElement("div_profile_join_loyalty");

            if (this._data.getBrandProperty("Settings").OOS.showAgeVerification && !profile.IsAge13)
                Util.showElement("div_profile_age_13");

            if (!this._user.getProperty("IsProfileComplete")) {
                Util.showElement("div_profile_terms_privacy_policy");
                if (!profile.Email) {
                    Util.showElement("div_profile_password1");
                    Util.showElement("div_profile_password2");
                }
            }
        } else {
            Util.showElement("div_profile_password1");
            Util.showElement("div_profile_password2");
            Util.showElement("div_profile_terms_privacy_policy");
            Util.hideElement("div_profile_addresses")
            Util.hideElement("div_profile_wallet")

            if (header) {
                header.innerText = this._localizationService.names("CreateAccount");
                header.setAttribute("ltag", "CreateAccount");
            }

            if (btn) {
                btn.innerText = this._localizationService.names("SignUp");
                btn.setAttribute("ltag", "SignUp");
                btn.onclick = function () { signUpFunction() };
            }

            if (this._context.getProperty("signUpLoyaltyLink")?.PhoneNumber)
                Util.setElement("value", "txt_profile_phone", Util.formatPhoneNumber(profile.Phone, this._localizationService.names("PhoneFormat", this._phoneFormatLanguage)));

            Util.setElement("disabled", "txt_profile_mark_promo_text", true);

            if (this._data.getBrandProperty("Settings").OOS.showAgeVerification)
                Util.showElement("div_profile_age_13");

            if (allergies && allergies.classList.contains("hidden") && dietary && dietary.classList.contains("hidden"))
                Util.setElementClass("add", "div_profile", "condensed");
        }

        if (this._data.getBrandProperty("Settings").OOS.birthdayField === BirthdayRequirement.DO_NOT_SHOW)
            Util.hideElement("div_profile_birthday");

        Util.setElement("value", "txt_profile_phone", Util.formatPhoneNumber(profile.Phone, this._localizationService.names("PhoneFormat", this._phoneFormatLanguage)));

        Util.setElement("value", "sel_profile_birth_month", profile.BirthMonth);
        Util.setElement("value", "sel_profile_birth_day", profile.BirthDay);
        Util.setElement("value", "txt_profile_mark_promo_text", (profile.MarketingPhone ? Util.formatPhoneNumber(profile.MarketingPhone, this._localizationService.names("PhoneFormat", this._phoneFormatLanguage)) : Util.formatPhoneNumber(profile.Phone, this._localizationService.names("PhoneFormat", this._phoneFormatLanguage))));

        setUserAllergiesFunction()
        setUserDietaryFunction()

        // 2DO: Maybe not needed
        // if (aOLO.isBrandSignIn)
        //     Util.showElement("div_profile_order_now");
        // else
        Util.hideElement("div_profile_order_now");

        Util.hideElement("div_profile_delete");
        Util.hideElement("div_chk_profile_survey");
        Util.hideElement("div_profile_allergies");
        Util.hideElement("div_profile_dietary");
        Util.hideElement("div_profile_join_loyalty");
        Util.hideElement("div_profile_unable_to_edit");
        if (!isSignUp) {
            Util.hideElement("btn_profile_profile");
            Util.showElement("div_profile_unable_to_edit");
        }
        this._makeProfileReadOnly(isSignUp);
    }

    renderAddressList = (profile: IProfile, addressEditFunction: Function, addressRemoveFunction: Function, addressSetDefaultFunction: Function): void => {
        let div = document.getElementById("div_profile_all_addresses");
        if (div) {
            div.innerHTML = "";

            profile.Addresses.forEach((address: any) => {
                let adr = `${address.STRNO} ${address.ADDR1}${address.ADDR2 ? ` #${address.ADDR2}` : ``}, ${address.CITY}, ${address.STA} ${address.ZIP}`;
                let html = `
                    <div id="div_profile_address_${address.AID}" class="m1-tb">
                        <span>${adr}</span> <br>
                    </div>`;

                if (div)
                    div.innerHTML += html;
            });
        }
    }

    private _makeProfileReadOnly = (isSignUp: boolean): void => {
        const profileInputs = document.querySelectorAll("[id^=txt_profile]");
        const profileCheckboxes = document.querySelectorAll("[id^=chk_profile]");
        const profileSelects = document.querySelectorAll("[id^=sel_profile]");
        const emailSelects = document.querySelectorAll("[id^=eml_profile]");

        if (!isSignUp) {
            profileInputs.forEach(input => {
                input.setAttribute("readonly", "true");
            });

            emailSelects.forEach(input => {
                input.setAttribute("readonly", "true");
            });

            profileCheckboxes.forEach(checkbox => {
                checkbox.setAttribute("disabled", "true");
            });

            profileSelects.forEach(select => {
                select.setAttribute("disabled", "true");
            });

            return;
        }

        profileInputs.forEach(input => {
            input.removeAttribute("readonly");
        });

        emailSelects.forEach(input => {
            input.removeAttribute("readonly");
        });

        profileCheckboxes.forEach(checkbox => {
            checkbox.removeAttribute("disabled");
        });

        profileSelects.forEach(select => {
            select.removeAttribute("disabled");
        });
    }

    postOrder = async (redemptionIds?: number[] | undefined): Promise<void> => {
        const payload: ICreateFinishOrderPayloadLoyaltyResult = {
            store_key: this._data.getProperty("StoreInfo")?.storeKey || "",
            data: {
                user_id: this._user.user?.LoyaltyReferenceID ? Number(this._user.user?.LoyaltyReferenceID) : null,
                check_in: false,
                pos_version: "2",
                order_id: this._order.getProperty("OrderID"),
                is_posted: false,
                status_id: 1,
                receipt_datetime: "",
                order_type_sub_type_id: this._order.getProperty("OrderTypeSubID").toString(),
                order_type_sub_type_name: "",
                subtotal_amount: Number((this._order.getProperty("SubTotal") - this._order.getProperty("Discount")).toFixed(2)),
                gross_amount: this._order.getProperty("Total"),
                email: this._user.user?.Email || "",
                employee_id: 0,
                employee_name: "",
                redemption_ids: [],
                menu_items: [],
                items: []
            }
        };

        await this._loyaltyService.postOrderAsync(payload);
    }

    getPointsToNextReward(): { points: number, reward: IDataReward | null } {
        const points: { points: number, reward: IDataReward | null } = { points: 99999, reward: null };
        return points;
    }

    async getPointsAsync(): Promise<number> {
        return 0;
    }

    getUserAvailableLoyaltyPoints(): number {
        return 0;
    }
}
